import { SxProps } from "@mui/material";


export const sxTypographyAdvice: SxProps = {
    color: '#5F5F5F',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceBold: SxProps = {
    color: '#383838',
    fontFamily: 'UnimedSans-Bold',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
    color: '#383838',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
}